import { render } from "./DeviceGradeModalV2.vue?vue&type=template&id=53e2e1f0&scoped=true&ts=true&lang=pug"
import script from "./DeviceGradeModalV2.vue?vue&type=script&lang=ts"
export * from "./DeviceGradeModalV2.vue?vue&type=script&lang=ts"

import "./DeviceGradeModalV2.vue?vue&type=style&index=0&id=53e2e1f0&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53e2e1f0"]])

export default __exports__